import React from 'react'
import PropTypes from 'prop-types';
import './style-card.css'
import { Icon } from '@fluentui/react';
import { Col, Row } from 'react-bootstrap';

function ItemTypeCard(props) {
    //Parametros de entrada.
    const {
        inputParam_Item = null,
        inputParam_SelectedItem = null,
        inputParam_ArrayLength = 0,
        inputParam_Index = 0,
        inputParam_SetterSelectedItem = null,
    } = props;
    
    const onStadisticCardSelected = () => {
        if (inputParam_SelectedItem && inputParam_Item.type === inputParam_SelectedItem.type) {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(null);
        }
        else {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(inputParam_Item);
        }
    }

    return (
            <div onClick={onStadisticCardSelected} className={ inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type ? "selected-stadistic-card" : ""} length={inputParam_ArrayLength}  style={{cursor: "pointer", borderRight: inputParam_ArrayLength > inputParam_Index ? "1px solid #b7b7b7" : ""}}>
                <Row style={{display: inputParam_Item.display ? "" : "none"}}>
                    <Col className="text-center col-mx-auto col pb-4 mb-3">
                        {
                            inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type &&
                            <Icon style={{ fontSize: "x-small", fontWeight: "600", color: "orange", position: "absolute", marginLeft: "-24px" }} iconName="Glimmer" />
                        }
                        <Icon style={{ fontFamily: "FabricMDL2Icons", fontSize: 25, verticalAlign: "middle", fontWeight: "400", color: inputParam_Item.color, position: "absolute", marginLeft: "-12px" }} iconName={inputParam_Item.icon} />
                    </Col>
                </Row>
                <Row style={{display: inputParam_Item.display ? "" : "none"}}>
                    <Col style={{fontSize: "small"}} className="text-center col-mx-auto">
                        {inputParam_Item.title}
                    </Col>
                </Row>
            </div>
    );
}

///Proptypes
ItemTypeCard.propTypes = {
    inputParam_Item: PropTypes.object.isRequired,
    inputParam_SelectedItem: PropTypes.object,
    inputParam_ArrayLength: PropTypes.number.isRequired,
    inputParam_Index: PropTypes.number.isRequired,
    inputParam_SetterSelectedItem: PropTypes.func.isRequired,
};

export default ItemTypeCard;